import React from 'react';
import { WDHLocationsSpot, ListPaginated, GoogleMap, Search
// FilterList,
// SearchFilterButton,
// } from '../../../../wdh-feature/wdh-locations-spot';
} from './wdh-locations-spot/index';
var locationsSpot = new WDHLocationsSpot();
var locationsSpotElem = document.querySelector(".".concat(locationsSpot.getClassName()));

// Search Component Only
if (locationsSpotElem && locationsSpotElem.classList.contains('location-spot-search')) {
  locationsSpot.addDesktopView(/*#__PURE__*/React.createElement(Search, {
    key: "search"
  }));
  locationsSpot.addMobileView(/*#__PURE__*/React.createElement(Search, {
    key: "search"
  }));
} else {
  // DESKTOP LAYOUT
  locationsSpot.addDesktopView(/*#__PURE__*/React.createElement(ListPaginated, {
    key: "list",
    header: [/*#__PURE__*/React.createElement(Search, {
      key: "search"
    })],
    locationsStateHash: "temp"
  }));
  locationsSpot.addDesktopView(/*#__PURE__*/React.createElement(GoogleMap, {
    key: "map"
  }));

  // MOBILE LAYOUT
  // locationsSpot.addMobileView(<FilterList key="filterList" />);
  locationsSpot.addMobileView(/*#__PURE__*/React.createElement(Search, {
    key: "search"
  }));
  locationsSpot.addMobileView(/*#__PURE__*/React.createElement(GoogleMap, {
    key: "map"
  }));
  locationsSpot.addMobileView(/*#__PURE__*/React.createElement(ListPaginated, {
    key: "list",
    locationsStateHash: "temp"
  }));
}
locationsSpot.run();